import Matter from "matter-js"

export function scrollToTop() {
	window.scrollTo(0, 0)
}

export function textHeight(drawingContext, text) {
	var metrics = drawingContext.measureText(text);
	return metrics.actualBoundingBoxAscent+metrics.actualBoundingBoxDescent; //width;
}

export function makePhysicsCharacter(p5, x, y, char, fontSize, options) {
	let charWidth = p5.textWidth(char);
	let charHeight = textHeight(p5.drawingContext, char)
	var body = Matter.Bodies.rectangle(x, y, charWidth, charHeight, options);
	body.label = char
	body.isCharacter = true
	body.restitution = 0.0
	body.dimension = {width: charWidth, height: charHeight}
	body.fontSize = fontSize

	return body
}

export function makeWalls(p5, top, bottom, left, right) {
	const wallThickness = 20
	var walls = []

	if (top) {
		walls.push(Matter.Bodies.rectangle(p5.width/2, -wallThickness/2, p5.width, wallThickness, { isStatic: true })) // top wall
	}
	if (bottom) {
		walls.push(Matter.Bodies.rectangle(p5.width/2, p5.height+wallThickness/2, p5.width, wallThickness, { isStatic: true })) // bottom wall
	}
	if (right) {
		walls.push(Matter.Bodies.rectangle(p5.width+wallThickness/2, p5.height/2, wallThickness, p5.height, { isStatic: true })) // right wall
	}
	if (left) {
		walls.push(Matter.Bodies.rectangle(-wallThickness/2, p5.height/2, wallThickness, p5.height, { isStatic: true })) // left wall
	}

	return walls
}

export function drawPhysicsCharacter(p5, body, debug) {
	if (body.isCharacter) {
		if (debug) {
			var context = p5.drawingContext;

			context.beginPath();

			var vertices = body.vertices;

			context.moveTo(vertices[0].x, vertices[0].y);

			for (var j = 1; j < vertices.length; j += 1) {
				context.lineTo(vertices[j].x, vertices[j].y);
			}

			context.lineTo(vertices[0].x, vertices[0].y);

			context.moveTo(vertices[0].x, vertices[0].y);
			context.lineTo(vertices[2].x, vertices[2].y);
			context.moveTo(vertices[1].x, vertices[1].y);
			context.lineTo(vertices[3].x, vertices[3].y);

			context.lineWidth = 1;
			context.strokeStyle = '#999';
			context.stroke();

			/*p5.stroke(255, 0, 0)
			p5.fill(255, 0, 0)
			p5.circle(body.position.x, body.position.y, 3)*/
		}
		p5.textSize(body.fontSize)

		p5.push()
		p5.translate(body.position.x, body.position.y)
		p5.rotate(body.angle)
		p5.translate(-body.dimension.width/2, body.dimension.height/2)
		p5.noStroke()
		p5.fill(255, 255, 255)
		p5.text(body.label, 0, 0)
		p5.pop()
	}
}

export function getRandomInt(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min)) + min;
}

export function randomChoice(arr) {
    return arr[Math.floor(arr.length * Math.random())];
}

export function maybe() {
	return randomChoice([true, false])
}

Math.fmod = function (a,b) { return Number((a - (Math.floor(a / b) * b)).toPrecision(8)); };
Math.frac = function (p) {return p - Math.floor(p)}

export class Voss {
	constructor() {
		this.VOSS_GENS = 4
		this.gens = new Array(this.VOSS_GENS)
		this.valnr = 0
		this.result = 0

		for (var i = 0; i < this.VOSS_GENS; i++) {
			this.gens[i] = Math.random()
			this.result += this.gens[i]
		}
	}

	tick() {
		this.result = 0;
		for(var i = 0; i < this.VOSS_GENS; i++) {
			if(Math.fmod(this.valnr, Math.pow(2.0, i)) === 0) {
				this.gens[i] = Math.random();
			}
			this.result += this.gens[i];
		}
		this.valnr++;
	}

	getValue() {
		return this.result / this.VOSS_GENS
	}
}
